import { ICON_COLORS, STROKE_COLORS, SURFACE_COLORS, TEXT_COLORS } from '~/utils/colors.ts';

export function classNames(obj: Record<string, boolean>): string {
    return Object.keys(obj)
        .filter((k) => obj[k])
        .join(' ');
}

export type IconColor = (typeof ICON_COLORS)[number];
export type TextColor = (typeof TEXT_COLORS)[number];
export type StrokeColor = (typeof STROKE_COLORS)[number];
export type SurfaceColor = (typeof SURFACE_COLORS)[number];

export function iconColorVar(color: IconColor): string {
    return `--icon-${color}`;
}

export function textColorVar(color: TextColor): string {
    return `--text-${color}`;
}

export function strokeColorVar(color: StrokeColor): string {
    return `--stroke-${color}`;
}

export function surfaceColorVar(color: SurfaceColor): string {
    return `--surface-${color}`;
}
